// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_cz-0";
export var fileCarousel = "_cz-2";
export var removeFileButton = "_cz-1";